<template>
<div class="map-btn-container">
    <yandex-map :coords="coords" :zoom="10" @map-was-initialized="onInit" :controls="controls" :use-object-manager="true">
        <point-panel :content="pointPanel" :selected-point-id="selectedPoint.id" :body="filteredPoints" :groupping="groupBy" @groupping-change="grouppingChange" @close="onPanelChangeView(false)" @open="onPanelChangeView(true)" @filter-confirm="onFilterConfirm" @point-select="pointSelect" />
        <timeline :selected="period" @dateChange="dateChange" />
        <router-view />
    </yandex-map>
</div>
</template>

<script>
import Vue from 'vue'
import { MapModules } from '../MapModules.js';
import timeline from './TimelineComponent.vue';
import pointPanel from './PanelComponent.vue';
import popupPage from './PageComponent.vue';
import popupPoint from './PointComponent.vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/point/:id',
        name: 'popup-point',
        component: popupPoint,
    },
    {
        path: '/:type/:id',
        name: 'popup-page',
        component: popupPage,
    },
]

const router = new VueRouter({routes});

export default {
    router,
    computed: {
        filteredPoints() {
            return this.$store.state.points.features.filter(this.filtering);
        },
        filter() {
            return this.$store.state.filter;
        },
        points() {
            return this.$store.state.points;
        },
        timeline() {
            return this.$store.state.timeline;
        }
    },
    data: () => ({
        coords: [58.59, 49.66],
        controls: ['geolocationControl', 'zoomControl'],
        period: null,
        groupBy: null,
        pointPanel: {
            head: '',
            show: true
        },
        selectedPoint: {
            id: 0,
            poly: null
        }
    }),
    methods: {
        // рисуем полигон вокруг точки, если он есть в свойствах объекта
        setPoly() {
            if (this.selectedPoint.id > 0){
                if (this.selectedPoint.poly != null)
                    window.myMap.geoObjects.remove(this.selectedPoint.poly)
                var point = this.points.features.find(point => (point.id == this.selectedPoint.id))
                if (point.geometry.poly) {
                    this.selectedPoint.poly = new window.ymaps.Polygon([
                        // Координаты контура.
                        this.transformPolyPoint(JSON.parse(point.geometry.poly))
                    ], {
                        hintContent: point.properties.balloonContentBody
                    }, {
                        fillColor: '#6699ff',
                        // Делаем полигон прозрачным для событий карты.
                        interactivityModel: 'default#transparent',
                        strokeWidth: 1,
                        opacity: 0.5
                    });
                    window.myMap.geoObjects.add(this.selectedPoint.poly);
                    window.myMap.setBounds(this.selectedPoint.poly.geometry.getBounds());
                }
                if (point.geometry.line) {
                    this.selectedPoint.poly = new window.ymaps.Polyline(
                        // Координаты контура.
                        this.transformPolyPoint(JSON.parse(point.geometry.line))
                    , {
                        hintContent: point.properties.balloonContentBody
                    }, {
                        draggable: false,
                        strokeColor: '#000000',
                        strokeWidth: 2,
                        // Первой цифрой задаем длину штриха. Второй — длину разрыва.
                        strokeStyle: '5 3'
                    });
                    window.myMap.geoObjects.add(this.selectedPoint.poly);
                    window.myMap.setBounds(this.selectedPoint.poly.geometry.getBounds());
                }
            }
        },
        transformPolyPoint(arr) {
            let out = []
            arr.forEach(p => {out.push([p[1], p[0]])})
            return out

        },
        // клик по точке
        pointSelect(point) {
            this.selectedPoint.id = point.id;

            // рисуем полигон, если есть о нем данные
            this.setPoly();

            // Отображаем баллун точки
            MapModules.getBallun(point);

            // Меняем хеш в Url
            history.replaceState(null, null, document.location.pathname + '#/point/' + point.id);
        },
        // применяем фильтры
        filtering(point) {
            return (point.properties.date < this.timeline.data[this.period - 1]?.stop) && // фильтр по таймкоду
                (this.filter.depth.length == 0   || this.filter.depth.indexOf(String(point.properties.depth)) != -1) &&     // фильтр по глубине
                (this.filter.manager.length == 0 || this.filter.manager.indexOf(point.properties.manager) != -1) &&         // фильтр по руководителю
                (this.filter.works.length == 0   || this.filter.works.indexOf(point.properties.type) != -1)                 // фильтр по типу работ
        },
        // обработка применения фильтра
        onFilterConfirm() {
            // обновление карты
            this.updateMap();
        },
        // действия после инициализации карты
        onInit(e) {
            // запоминаем карту в глобальной переменной
            window.myMap = e;
            // активируем режим тепловой карты НЕ РАБОТАЕТ
            // MapModules.HeatmapDefine();
            // var data = [
            //     [54, 39]
            // ];
            // MapModules.HeatmapSet(data);
            // активируем свою подложку для карты
            MapModules.UserLayerInit('Историческая', ((window.mymappath)?window.mymappath:'')+'my/');
            // активируем свои органы управления на карте
            MapModules.buttonsInit(this);
            // загружаем основной контент
            this.created();
        },
        // изменился способ группировки объектов
        grouppingChange(selected) {
            // смена указателя текущей группировки
            this.groupBy = selected;
            // меняем цвета меток согласно настройкам группировки
            // eslint-disable-next-line
            objectManager.objects.each(point => {
                // eslint-disable-next-line
                objectManager.objects.setObjectOptions(point.id, {
                    iconColor: this.setPointColor(point)
                });
            });
            // обновление карты
            var currentZoom = window.myMap.getZoom();
            window.myMap.setZoom(4, { duration: 1000 });
            window.myMap.setZoom(currentZoom, { duration: 1000 });
        },
        // изменился текущий временной период
        dateChange(item) {
            // смена указателя текущего периода
            this.period = item.npp;
            // смена заголовка панели объектов
            this.pointPanel.head = 'Работы в периоде ' + item.text;
            // обновление карты
            this.updateMap();
        },
        // настройка цветов маркеров в зависимости от вида группировки
        setPointColor(point) {
            if (this.groupBy == "depth")
                return this.$store.getters.getDepth(point.properties.depth).color;
            if (this.groupBy == "work")
                return this.$store.getters.getWork(point.properties.type).color;
            if (this.groupBy == "manager")
                return this.$store.getters.getManager(point.properties.manager).color;
            else return '#000000';
        },
        // обновление карты
        updateMap() {
            //применяем фильтр на карте
            // eslint-disable-next-line
            objectManager.setFilter(point => this.filtering(point));
            // реактивируем панель поиска по объектам на карте
            MapModules.MySearthInit(this.filteredPoints);
            // выключаем полосу загрузки
            this.$Loading.finish();
        },
        // настраиваем область видимости карты (чтобы объекты не отображались под панелью)
        addPanelArea(panel, width) {
            // если область видимости уже была настроена - удаляем её
            if (window.accessor) window.accessor.remove();
            // если пришла команда true - добавляем область на карту
            if (panel && width > 500) {
                window.accessor = window.myMap.margin.addArea({
                    top: 0,
                    left: 0,
                    width: '300px',
                    height: '100%'
                });
            }
            if (panel && width <= 500) {
                window.accessor = window.myMap.margin.addArea({
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '290px'
                });
            }
            if (!panel && width <= 500) {
                window.accessor = window.myMap.margin.addArea({
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '110px'
                });
            }
        },
        // скрытие/показ панели объектов
        onPanelChangeView(show) {
            // обновляем флаг показа панели
            this.pointPanel.show = show;
            // настраиваем область видимости карты (чтобы объекты не отображались под панелью)
            this.addPanelArea(show, document.body.clientWidth);
            // ориентируем карту на показ всех доступных объектов в видимой области
            // eslint-disable-next-line
            window.myMap.setBounds(objectManager.getBounds(), { 
                useMapMargin: true, 
                zoomMargin: 5, 
                preciseZoom: true, 
                duration: 300 
            });
            if (this.selectedPoint.id > 0) {
                this.pointSelect(this.selectedPoint);
                // промотка списка точек
                setTimeout(() => {
                    let item = document.getElementById('item_' + this.selectedPoint.id);
                    if (item) item.scrollIntoView();
                }, 500);
            }
        },
        // загрузка массива точек
        async pointsLoad() {
            this.$store.dispatch('pointsLoader').catch(this.$Loading.error)
                .then(() => {
                    // Создание менеджера объектов.
                    // eslint-disable-next-line
                    window.objectManager = new ymaps.ObjectManager({
                        clusterize: true,
                        clusterHasBalloon: true,
                        clusterIconLayout: 'default#pieChart'
                    });
                    // После создания менеджера ему следует передать JSON-описание объектов.
                    // eslint-disable-next-line
                    objectManager.add(this.points);

                    // добавляем новые объекты
                    // eslint-disable-next-line
                    window.myMap.geoObjects.add(objectManager);

                    // применяем настройки группировки
                    this.grouppingChange(this.groupBy);

                    // настраиваем область видимости карты (чтобы объекты не отображались под панелью)
                    this.addPanelArea(this.pointPanel.show, document.body.clientWidth);

                    // обновляем точки на карте
                    this.updateMap();

                    // ориентируем карту на показ всех доступных объектов в видимой области
                    // eslint-disable-next-line
                    window.myMap.setBounds(objectManager.getBounds(), { 
                        useMapMargin: true, 
                        zoomMargin: 5, 
                        preciseZoom: true, 
                        duration: 1000 
                    });

                    // добавляем событие при клике на объекте
                    MapModules.ObjClickFunc(pointId => {
                        this.selectedPoint.id = pointId;
                        let item = document.getElementById('item_' + pointId);
                        if (item) item.scrollIntoView();
                        this.setPoly();
                        history.replaceState(null, null, document.location.pathname + '#/point/' + pointId);
                    });

                    // отображаем балун на точке, записанной в URL (если такая есть)
                    setTimeout(() => { this.pointHashSelect(window.hash) }, 1000);
            });
        },

        // показ точки по хешу
        pointHashSelect(hash) {
            hash = hash.split('/');
            if (hash.length == 3 && hash[1] == 'point' && hash[2] > 0) {
                var id = hash[2];
                var point = this.points.features.find(point => point.id == id);
                if (point) {
                    window.myMap.setZoom(18);
                    this.pointSelect(point);
                    // промотка списка точек
                    let item = document.getElementById('item_' + point.id);
                    if (item) item.scrollIntoView();
                } else this.$Message.error('Вызываемая точка не существует!')
            }
        },

        // Открываем первую страницу, если нет другого хеша
        getFirstPage(id) {
            if (!this.$route.params.id && window.hash.split('/').length < 3){
                    this.$router.push({ name: 'popup-page', params: { id, type: 'page' } })
                }
        },

        //действия при инициализации модуля (до загрузки карты)
        created() {
            // активация линии загрузки
            this.$Loading.start();
            // установка временного периода по умолчанию из справочника
            this.period = this.$store.state.timeline.current;
            // установка группировки по умолчанию из справочника
            this.groupBy = this.$store.state.groupping.current;

            // последовательно загружаем контент: страницы - категории - глубины - временные метки - руководители работ - работы
            this.$store.dispatch('pagesLoader').catch(()=>this.$Loading.error()).then(() => {
                // категории
                this.$store.dispatch('catsLoader').catch(()=>this.$Loading.error()).then(() => {
                    // Открываем первую страницу, если не указано иное
                    if(window.startpage) this.getFirstPage(window.startpage);
                    // глубины
                    this.$store.dispatch('depthsLoader').catch(()=>this.$Loading.error()).then(()=>{
                        // типы работ
                        this.$store.dispatch('worksLoader').catch(()=>this.$Loading.error()).then(()=>{
                            // временная шкала
                            this.$store.dispatch('timelineLoader').catch(()=>this.$Loading.error()).then(() => {
                                // Устанавливаем последнюю дату
                                this.pointPanel.head = 'Работы в периоде ' + this.$store.state.timeline.data[this.period - 1].text;
                                // руководители
                                this.$store.dispatch('managersLoader').catch(()=>this.$Loading.error()).then(()=>{
                                    // загружаем все точки с сервера
                                    this.pointsLoad();
                                })
                            })
                        })
                    })
                })
            })
        },
    },
    components: {
        // панель времени
        timeline,
        // панель объектов
        pointPanel
    },
    mounted () {
        // подписка на изменение хеша страницы для "ручного" выделения точки
        window.addEventListener('hashchange', e => {
            this.pointHashSelect(`#${e.newURL.split('#')[1]}`);
        });
    }
};
</script>

<style>

@import url(../assets/css/at-ui.css);

main {
    height: 100px;
}

footer {
    display: none;
}

#app,
.map-btn-container {
    width: 100%;
    height: calc(100vh - 55px);
    min-width: 300px;
    margin: 0;
    padding: 0;
}

.ymap-container {
    height: 100%;
    position: relative;
}
</style>
